// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  ServiceGetStatisticsResponse as GetStatisticsResponse,
  ServiceGetPropertiesResponse as GetPropertiesResponse,
  ServiceSetPropertiesOptionalParams as SetPropertiesOptions,
  TableServiceProperties as ServiceProperties,
  ServiceSetPropertiesResponse as SetPropertiesResponse,
  TableDeleteEntityResponse as DeleteTableEntityResponse,
  TableUpdateEntityResponse as UpdateEntityResponse,
  TableMergeEntityResponse as UpsertEntityResponse,
  TableSetAccessPolicyResponse as SetAccessPolicyResponse,
  TableInsertEntityHeaders,
  TableCreateHeaders,
  TableDeleteEntityHeaders,
  TableDeleteHeaders,
  TableGetAccessPolicyHeaders,
  ServiceGetPropertiesHeaders,
  ServiceGetStatisticsHeaders,
  GeoReplicationStatusType,
  KnownGeoReplicationStatusType,
  GeoReplication,
  TableServiceStats,
  TableMergeEntityHeaders,
  CorsRule,
  Metrics,
  RetentionPolicy,
  Logging,
  TableSetAccessPolicyHeaders,
  ServiceSetPropertiesHeaders,
  TableUpdateEntityHeaders,
} from "./generated/models/index.js";
